import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";


import { Container, Image, Nav, NavLink, Text, Left, Right, PoweredContainer, PoweredText, PoweredLogo, ClientLogo, RedCircle } from "./styles";
import { Link, useLocation } from "react-router-dom";
import Routes from "../../routes/main.routes";
import RoutesClient from "../../routes/mainClients.routes";

//Actions Functions
import { resetLogin } from "../../redux/actions/login";
import { clearHistory } from "../../redux/actions/messages";
import { clearBranchs } from "../../redux/actions/branchs";
import { closeSocket } from "../../redux/actions/socket"

//Assets
import Logo from "../../assets/img/logo.png";
import colors from "../../assets/css/colors";
import logoutIcon from "../../assets/icons/logout.svg";
import logoutHoverIcon from "../../assets/icons/logoutHover.svg";
import redCircle from "../../assets/icons/redCircle.svg";

//Interfaces
import RouteInterface from "../../routes/interfaces/mainRouteInterface";
import { addressImage } from "../../service/domains";

const Sidebar = () => {
  const [logoImg, setLogoImg] = useState("");
  const [hover, setHover] = useState("");
  const [path, setPath] = useState("");
  const [newMessages, setNewMessages] = useState(0)

  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const login = useSelector((state: {login : any}) => state.login);
  const websocket = useSelector((state: {websocket: any}) => state.websocket);
  const chatWithNewMessageIdList = useSelector((state: {chatWithNewMessageIdList: any}) => state.chatWithNewMessageIdList);

  const type = login.user.ownersId;

  const logoControllerChange = login.user.branchsId === null ? login.user.owners.standardLogo : login.user.branchs.standardLogo;

  //get the path name
 useEffect(() => {
    setPath(location.pathname)
  }, [location]);

  useEffect(() => {
    setNewMessages(newMessages + 1);
  }, [chatWithNewMessageIdList.list])

  useEffect(() => {
    if(login.user.branchsId !== null){
      setLogoImg(`${addressImage}${login.user.branchs.standardLogo}`);
    } else {
      setLogoImg(`${addressImage}${login.user.owners.standardLogo}`);
    }
  }, [logoControllerChange]);

  const getLogoImage = () => {
    if(login.user.ownersId !== null) {
      if(login.user.owners.standardLogo !== null){
        return `${login.user.owners.standardLogo}`
      } else if(login.user.powerUser === true && login.user.branchs !== null) {
        return `${login.user.branchs.standardLogo}`
      } else {
        return null;
      }
    } else {
      if(login.user.branchs.standardLogo !== null){
        return `${login.user.branchs.standardLogo}`
      } else {
        return null
      }
    } 
  }

  const renderMenu = () => {
    const routesToRender = type === null || login.user.powerUser === true ? RoutesClient : Routes;
    
    return routesToRender.map((prop: RouteInterface, key) => {
      if(type === null || login.user.powerUser === true){
        prop.id = prop.id !== undefined ? prop.id : ""; 
        
        if(login.user.groups[prop.id]){
          if (prop.layout === "/admin") {
            const mainPath = prop.layout+prop.path
            const isPath =  path.includes(mainPath);
            const isHover = hover === prop.name || isPath
            
            return (
              <Link
                onMouseEnter={() => setHover(prop.name)}
                onMouseLeave={() => setHover("")}
                key={key}
                to={{
                  pathname: `${prop.layout}${prop.path}`,
                }}
    
                style={{outlineColor: `${colors.primary}`, textDecoration:"none", color: (isHover || isPath )? colors.primary : colors.grayDark, display:"flex", alignItems:"center"}}
              >
                <NavLink id={prop.name}>
                  <Left>
                    <img
                      src={isHover || isPath ? prop.iconHover : prop.icon}
                      alt={prop.name}
                    />
                  </Left>
                  <Right>
                    <Text>{prop.name}</Text>
                  </Right>
                </NavLink>
              </Link>
            )
          } else {
            return null;
          }
        }
      } else if (prop.layout === "/admin") { //if(login.user.groups[prop.id]){ a ser aplicado quando houver sido feita alteração no usuário
        const mainPath = prop.layout+prop.path
        const isPath =  path.includes(mainPath);
        const isHover = hover === prop.name || isPath;
        
        if(prop.path === "/messages" && chatWithNewMessageIdList.list.length > 0){
          return (
            <Link
              onMouseEnter={() => setHover(prop.name)}
              onMouseLeave={() => setHover("")}
              key={key}
              to={{
                pathname: `${prop.layout}${prop.path}`,
              }}
  
              style={{textDecoration:"none", color: (isHover || isPath )? colors.primary : colors.grayDark, display:"flex", alignItems:"center", cursor: "pointer"}}
            >
              <NavLink>
                <Left>
                  <img
                    src={isHover || isPath ? prop.iconHover : prop.icon}
                    alt={prop.name}
                  />
                  <RedCircle/>
                </Left>
                <Right>
                  <Text>{prop.name}</Text>
                </Right>
              </NavLink>
            </Link>
          );
        } else {
          return (
            <Link
              onMouseEnter={() => setHover(prop.name)}
              onMouseLeave={() => setHover("")}
              key={key}
              to={{
                pathname: `${prop.layout}${prop.path}`,
              }}
  
              style={{textDecoration:"none", color: (isHover || isPath )? colors.primary : colors.grayDark, display:"flex", alignItems:"center", cursor: "pointer"}}
            >
              <NavLink>
                <Left>
                  <img
                    src={isHover || isPath ? prop.iconHover : prop.icon}
                    alt={prop.name}
                  />
                </Left>
                <Right>
                  <Text>{prop.name}</Text>
                </Right>
              </NavLink>
            </Link>
          );

        }
      } else {
        return null;
      }
    });
  };

  const handleLogout = () => {
    dispatch(resetLogin());
    dispatch(clearHistory());
    dispatch(clearBranchs());
    
    if(websocket.socket !== null){
      websocket.socket.disconnect();
    }
    dispatch(closeSocket());
    history.push("/auth/login");
  }

  return (
    <Container>
      <Image className="mt-5" src={getLogoImage() !== null ? logoImg : Logo} />      
      {/* <ClientLogo url={login.user.avatar !== null ? logoImg : Logo} className="mt-5"/> */}

      <Nav>{renderMenu()}</Nav>

      <div
        style={{textDecoration:"none", color: hover === "logout" ? colors.primary : colors.grayDark, display:"flex", alignItems:"center", cursor: "pointer"}}
        onClick={() => handleLogout()}
        onMouseEnter={() => setHover("logout")}
        onMouseLeave={() => setHover("")}
      >
        <NavLink>
          <Left>
            <img
              src={ hover === "logout" ? logoutHoverIcon : logoutIcon}
              alt="Sair"
            />
          </Left>
          <Right>
            <Text>Sair</Text>
          </Right>
        </NavLink>
      </div>

      <PoweredContainer>
        <PoweredText>powered by</PoweredText>
        <PoweredLogo className="ml-1" src={Logo} />
      </PoweredContainer>
      {/* <Perfilphoto /> */}
    </Container>
  );
};

export default Sidebar;
